import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import Company from 'src/app/model/company/company';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Contact from 'src/app/model/Contact/contact';

@Component({
  selector: 'company-display-dialog',
  templateUrl: './company-display-dialog.component.html',
  styleUrls: ['./company-display-dialog.component.scss'],
})
export class CompanyDisplayDialogComponent implements OnInit {
  @Input()
  company: Company;

  init: boolean = false;
  displayAddress: any;
  displayContacts: Contact[];

  constructor(
    public dialogRef: MatDialogRef<CompanyDisplayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.company = data.company;
  }

  ngOnInit(): void {
    this.preprocessAddress();
    this.preprocessContacts();
    this.init = true;
  }

  preprocessAddress(): void {
    if (
      this.company == null ||
      !CollectionHelper.isPopulated(this.company.addresses)
    ) {
      return;
    }
    let firstEncounteredAddress = null;
    for (const address of this.company.addresses) {
      if (firstEncounteredAddress == null) {
        firstEncounteredAddress = address;
      }
      if (address.type === 'primary') {
        this.displayAddress = address;
        return;
      }
    }
    if (firstEncounteredAddress != null) {
      this.displayAddress = firstEncounteredAddress;
    }
  }

  preprocessContacts(): void {
    this.displayContacts =
      this.company == null ||
      !CollectionHelper.isPopulated(this.company.contacts)
        ? null
        : this.company.contacts.filter(
            (c) => !c.archived && CollectionHelper.isPopulated(c.telephones)
          );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
